<script lang="ts">
    import { highlightMatch } from '$lib/utils';
    import { Avatar, Checkbox } from '@allibee/components';
    import { twMerge } from 'tailwind-merge';

    export let user: MtmUserDto;
    export let checked: boolean;
    export let keyword: string = '';

    const colorClass = 'text-primary-500';
    const bgColorClass = 'bg-primary-50';
    const hoverBgColorClass = 'hover:bg-primary-100';
    const borderColorClass = 'border-primary-500';

    function highlightMatchText(text: string, keyword: string) {
        return highlightMatch(text, keyword, colorClass);
    }
</script>

<button
    on:click
    on:keydown
    class={twMerge('inline-flex w-full cursor-pointer gap-2 rounded-lg border border-gray-200 bg-white p-4 hover:bg-gray-50', checked && `${bgColorClass} ${borderColorClass} ${hoverBgColorClass}`)}
>
    <div class="flex flex-row items-start">
        <Avatar name={user.displayName} />
    </div>
    <div class="inline-flex shrink grow basis-0 flex-col gap-1">
        <div class="flex justify-between">
            <div class="inline-flex items-center gap-1 self-stretch">
                <div class="text-xs font-bold text-gray-900">{@html highlightMatchText(user.displayName, keyword)}</div>
                <div class="text-xs text-gray-900">
                    {@html highlightMatchText(user.jobTitle?.name || '-', keyword)} / {@html highlightMatchText(user.jobPosition?.name || '-', keyword)}
                </div>
            </div>
            <Checkbox {checked} />
        </div>
        {#if user.groups?.length > 0}
            <p class="line-clamp-1 break-words text-start text-xs text-gray-900">
                {@html highlightMatchText(user.groups.map(group => group.groupName).join(', '), keyword)}
            </p>
        {/if}
        <p class="line-clamp-1 break-words text-start text-[0.6875rem] text-gray-500">
            {@html highlightMatchText(user.loginId || '-', keyword)}
        </p>
    </div>
</button>
